import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";

/**
 * Heading with in-page anchor link. Ported from GSA openacr-editor HeaderWithAnchor.svelte.
 */
export const anchorSvg = (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
    <path d="M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z" />
  </svg>
);

export default function HeaderWithAnchor({ id, level = 2, download = false, children }) {
  const extraId = download ? "-download" : "-editor";
  const Tag = level === 2 ? "h2" : "h3";

  return (
    <Tag className="relative">
      <Link
        to={`#${id}${extraId}`}
        id={`${id}${extraId}`}
        className="header-anchor absolute -left-8 opacity-40 text-sm no-underline hover:underline hover:opacity-100 focus:underline focus:opacity-100"
        aria-label="Anchor link"
      >
        {anchorSvg}
      </Link>
      {children}
    </Tag>
  );
}

HeaderWithAnchor.propTypes = {
  id: PropTypes.string.isRequired,
  level: PropTypes.oneOf([2, 3]),
  download: PropTypes.bool,
  children: PropTypes.node,
};

HeaderWithAnchor.defaultProps = {
  level: 2,
  download: false,
  children: null,
};
